import { supabase } from '@/lib/supabase';

export interface UpdateProjectConnectionInput {
  projectId: number;
  connectedProjectId: number | null;
}

export const updateProjectConnection = async ({
  projectId,
  connectedProjectId,
}: UpdateProjectConnectionInput): Promise<void> => {
  const { error } = await supabase
    .from('projects')
    .update({
      connected_project: connectedProjectId,
    })
    .eq('id', projectId);

  if (error) {
    throw error;
  }
};
